import * as ProductsAction from "../products/ProductsAction";

export default function productsReducer(state = {}, action) {
    switch (action.type) {
        case ProductsAction.REQUEST_PRODUCTS_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    ...action.payload
                };
            }
        case ProductsAction.REQUEST_PRODUCT_SUBSCRIPTION_TYPES_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    subscriptionTypesForCurrentProduct: {
                        ...action.payload
                    }
                };
            }
            case ProductsAction.REQUEST_PRODUCT_MODULE_PRICING_LEVELS_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    modulePricingLevels: {
                        ...action.payload
                    }
                };
            }
        default:
            return state;
    }
}
